





































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import VrTagMovieDialog from "@/components/vr-tags/VrTagMovieDialog.vue";
import { TagContentsParam } from "@/params/TagContentsParam";

@Component({
  components: {
    VrTagMovieDialog
  }
})
export default class VrTagProductMovieDialog extends Vue {
  @Prop() isShown: boolean;
  @Prop() contents: TagContentsParam;

  @Emit('close')
  onCloseDialog (): void {}
}
